export const getDefaultState = () => {
  return {
    profile:{}
  }
}

// initial state
const state = getDefaultState();

export default state;